import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";
import { getInitials } from "helpers";
import { connect } from "react-redux";
import * as actions from "redux/actions/historyActions";
// import Delete from "@material-ui/icons/Delete";
// import StarIcon from '@mui/icons-material/Star';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
import MiniLoader from "components/MiniLoader";
import StockAvatar from "components/StockAvatar";
import { Translate, I18n } from "react-redux-i18n";
import { Star, Trash } from 'theme/icon';
import { confirmDelete } from 'utils/confirmDialog';
import 'assets/css/history.css';

const useStyles = {
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 1050,
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  actions: {
    justifyContent: "center",
  },
  avatar: {
    marginRight: '7px',
    height: 30,
    width: 30,
    flexDirection: 'row',
    position: "absolute",
    borderRadius: "5px"
  },
};

const stylesLocal = {
  subcell: {
    padding: "5px"
  },
  cell: {
    padding: "5px"
  }
};

function toNum(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function calcPl(item) {
  return toNum(item.open_trade) + toNum(item.close_trade) - toNum(item.tax);
}

function calcPlPercent(item) {
  const openTrade = Math.abs(toNum(item.open_trade));
  if (openTrade === 0) {
    return null;
  }
  const gross = toNum(item.open_trade) + toNum(item.close_trade);
  return (gross / openTrade) * 100;
}

function pl(items) {
  const total = items.reduce((sum, item) => sum + calcPl(item), 0);
  return total.toFixed(2);
}

function formatPl(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '—';
  }
  return n.toFixed(2);
}

const Table_ = (props) => {
  const { className, list, history, ...rest } = props;


  const [selectedList, setSelectedList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const handleSelectAll = (event) => {
    // const { list } = props;

    let selectedList;

    if (event.target.checked) {
      selectedList = list.map((item) => item.id);
    } else {
      selectedList = [];
    }
    setSelectedList(selectedList);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedList.indexOf(id);
    let newSelectedList = [];

    if (selectedIndex === -1) {
      newSelectedList = newSelectedList.concat(selectedList, id);
    } else if (selectedIndex === 0) {
      newSelectedList = newSelectedList.concat(selectedList.slice(1));
    } else if (selectedIndex === selectedList.length - 1) {
      newSelectedList = newSelectedList.concat(selectedList.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedList = newSelectedList.concat(
        selectedList.slice(0, selectedIndex),
        selectedList.slice(selectedIndex + 1)
      );
    }

    setSelectedList(newSelectedList);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const onClickDelete = (item) => {
    //  console.log(item);
    confirmDelete(I18n.t('delete_confirm_message'), () => {
      props.removeItem(
        {
          history_id: item.id,
          symbol: item.symbol,
          id: props.user_id,
        },
        props.token,
      );
    });
  };

  const onClickLoadMore = () => {
    if (props.loadingMore || props.pageSize < 25) {
      return;
    }
    props.loadMore(
      {
        ...props.query,
        index: props.list.length,
        id: props.user_id,
      },
      props.token,
    );
  };

  return (
    <div className=''  >
            <table className="table table-hover history-table">
              <thead>
                <tr>
                  <th align="left">Symbol</th>
                  <th>Kind</th>
                  <th>Qtt</th>
                  <th>Open Price</th>
                  <th>Close Price</th>
                  <th>Open Date</th>
                  <th>Close Date</th>
                  <th>Expire Date</th>
                  <th>Reference</th>
                  <th align="right">Stk</th>
                  <th align="right">Open Trade</th>
                  <th align="right">Close Trade</th>
                  <th align="right">Tax</th>
                  <th align="right">P/L</th>
                  <th align="right">P/L %</th>
                  <th align="right">A</th>
                </tr>
              </thead>
              <tbody>
                {props.list.map((item) => {
                  const plValue = calcPl(item);
                  const plPercent = calcPlPercent(item);
                  const plColor = plValue < 0 ? 'red' : 'green';

                  return (
                  <tr
                    className={''}
                    // hover
                    key={item.id}
                    selected={item.open_at === item.close_at}

                  >
                    <th >
                      <div className='symbol-cell'>
                          <StockAvatar item={item} symbol={item.symbol} className="avatar-sm" />
                           <div className="symbol-meta">
                          <RouterLink to={"/stock/" + item.symbol} className="symbol-link">{item.symbol.toUpperCase()}</RouterLink>
                          {
                            item.dividend === "1" && 
                            (<Star className="symbol-star" />)
                          }
                          </div>
                    </div>
                    </th>
                    <th style={stylesLocal.cell}>{item.kind}</th>
                    <th style={stylesLocal.cell}>
                      {item.counter && item.counter > 1
                        ?
                        (item.quantity)
                        :
                        ((item.market === "SELL" ? "-" : "+") + (item.quantity) + (item.kind === "OPTION" ? (item.option_kind === "CALL" ? "C" : "P") : ("")))
                      }
                    </th>
                    <th style={stylesLocal.cell}>{item.open_price}{" "}{item.kind === "OPTION" && (item.market === "SELL" ? "STO" : "BTO")}</th>
                    <th style={stylesLocal.cell}>{item.close_price}{" "}{item.kind === "OPTION" && (item.market === "SELL" ? "BTC" : "STC")}</th>
                    <th style={stylesLocal.cell}>
                      {moment(item.open_at).zone("+00:00").format("DD/MM/YYYY")}
                    </th>
                    <th style={stylesLocal.cell}>
                      {moment(item.close_at).zone("+00:00").format("DD/MM/YYYY")}
                    </th>
                    <th style={stylesLocal.cell}>
                      {item.kind === "OPTION" && moment(item.expire_at).zone("+00:00").format("DD/MM/YYYY")}
                    </th>
                    <th style={stylesLocal.cell} >
                      {item.reference}
                    </th>
                    <th style={stylesLocal.cell} align="right">{item.kind === "OPTION" && item.strike}</th>
                    <th style={stylesLocal.cell} align="right">
                      {item.open_trade}
                    </th>
                    <th style={stylesLocal.cell} align="right">
                      {item.close_trade}
                    </th>
                    <th style={stylesLocal.cell} align="right">
                      {item.tax}
                    </th>
                    <th style={stylesLocal.cell} align="right">
                      <span style={{ color: plColor }}>
                        {formatPl(plValue)}
                      </span>
                    </th>
                    <th style={stylesLocal.cell} align="right">
                      {plPercent != null ? (
                        <span style={{ color: plColor }}>
                          {formatPl(plPercent)}%
                        </span>
                      ) : '—'}
                    </th>
                    <th style={stylesLocal.cell}>
                      {
                        item.counter && item.counter > 1
                          ? (<></>)
                          : (<span className="icon-button"
                            size="small"
                            onClick={() => { onClickDelete(item) }}
                          >
                            <Trash />
                          </span>)
                      }

                    </th>
                  </tr>
                  );
                })}
                <tr className="history-table-total">
                  <th colSpan={13}>Total</th>
                  <th align="right">${pl(list)}</th>
                </tr>
              </tbody>
            </table>
         
      <div className={''}>
        {
          props.pageSize === 25 && (
            props.loadingMore ? (
              <MiniLoader />
            ) : (
              <button className="btn btn-primary" onClick={onClickLoadMore}>
                <Translate value="load_more" />
              </button>
            )
          )
        }

      </div>
  </div>
  );
};

Table_.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array.isRequired,
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    auth: reducer.session.auth,

    list: reducer.history.list,
    error: reducer.history.error,
    loading: reducer.history.loading,

    search: reducer.history.search,

    loadingMore: reducer.history.loadingMore,
    pageSize: reducer.history.page_size,
    pageCount: reducer.history.page_count,
    query: reducer.history.query,
  };
}

const mapDispatchToProps = dispatch => ({
  loadMore: (params, token) =>
    dispatch(actions.loadListScroll({ params, token })),
  removeItem: (params, token) =>
    dispatch(actions.removeItem({ params, token })),

});
export default connect(mapStateToProps, mapDispatchToProps)(Table_);
/**.slice((page * rowsPerPage), (rowsPerPage * (page + 1)))
 *  <TablePagination
          component="div"
          count={list.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
 * <TableCell>
                      {item.year}
                    </TableCell>
                    <TableCell>
                      {item.color}
                    </TableCell>
                     <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedList.length === list.length}
                      color="primary"
                      indeterminate={
                        selectedList.length > 0 &&
                        selectedList.length < list.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>

                   <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedList.indexOf(item.id) !== -1}
                        color="primary"
                        onChange={(event) => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
 */
